import React from 'react';
import EmailSubscribe from './EmailSubscribe';

interface GameCTAProps {
  title: string;
  description: string;
  gradientFrom: string;
  gradientTo: string;
}

const GameCTA: React.FC<GameCTAProps> = ({ title, description, gradientFrom, gradientTo }) => {
  return (
    <section className={`text-center bg-gradient-to-r ${gradientFrom} ${gradientTo} rounded-lg p-8 text-white`}>
      <h2 className="text-3xl font-bold mb-4">{title}</h2>
      <p className="text-lg mb-6 opacity-90">
        {description}
      </p>
      <EmailSubscribe variant="inline" className="max-w-2xl mx-auto" />
    </section>
  );
};

export default GameCTA;
